import { clear, el, icon } from "./dom";

export type ToastKind = "success" | "error" | "info";

export interface ToastOptions {
  kind?: ToastKind;
  title: string;
  message?: string;
  timeoutMs?: number;
}

const DEFAULT_TIMEOUT_MS = 4500;
const MAX_TOASTS = 2;

export class ToastCenter {
  constructor(
    private readonly container: HTMLElement,
    private readonly max: number = MAX_TOASTS,
  ) {}

  show(options: ToastOptions): void {
    const kind = options.kind ?? "info";
    const toast = el("div", { className: `toast toast--${kind}` });
    if (kind === "error") toast.setAttribute("role", "alert");

    const body = el("div", { className: "toast__body" });
    body.append(el("p", { className: "toast__title", text: options.title }));
    if (options.message !== undefined && options.message !== "") {
      body.append(el("p", { className: "toast__message", text: options.message }));
    }

    const close = el("button", { className: "toast__close" });
    close.type = "button";
    close.title = "Cerrar aviso";
    close.setAttribute("aria-label", "Cerrar aviso");
    close.append(icon("i-close"));
    close.addEventListener("click", () => this.dismiss(toast));

    toast.append(body, close);
    this.container.append(toast);
    this.trim();

    const timeout = options.timeoutMs ?? DEFAULT_TIMEOUT_MS;
    window.setTimeout(() => this.dismiss(toast), timeout);
  }

  private dismiss(toast: HTMLElement): void {
    if (!toast.isConnected) return;
    toast.classList.add("toast--leaving");
    window.setTimeout(() => toast.remove(), 200);
  }

  private trim(): void {
    const toasts = [...this.container.children];
    for (const extra of toasts.slice(0, Math.max(0, toasts.length - this.max))) {
      extra.remove();
    }
  }

  clear(): void {
    clear(this.container);
  }
}
